import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as React from 'react';

import { cn } from '@/services/utils';

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverPortal = PopoverPrimitive.Portal;

interface PopoverContentProps extends React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> {
    hasBorder?: boolean;
    hasPadding? : boolean;
}

const PopoverContent = React.forwardRef<
    React.ElementRef<typeof PopoverPrimitive.Content>,
    PopoverContentProps
>(({ className, align = 'center', sideOffset = 4, hasBorder = false, hasPadding = true, ...props }, ref) => (
    <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
            `tw-z-[1050]
             tw-w-72
             tw-rounded
             tw-bg-fill-primary
             tw-text-popover-foreground
             tw-shadow-lg
             tw-outline-none
             data-[state=open]:tw-animate-in
             data-[state=closed]:tw-animate-out
             data-[state=closed]:tw-fade-out-0
             data-[state=open]:tw-fade-in-0
             data-[state=closed]:tw-zoom-out-95
             data-[state=open]:tw-zoom-in-95
             data-[side=bottom]:tw-slide-in-from-top-2
             data-[side=left]:tw-slide-in-from-right-2
             data-[side=right]:tw-slide-in-from-left-2
             data-[side=top]:tw-slide-in-from-bottom-2`,
            hasBorder ? 'tw-border tw-border-solid tw-border-primary' : '',
            hasPadding ? 'tw-p-4': '',
            className
        )}
        {...props}
    />
));

PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverContent, PopoverPortal, PopoverTrigger };
